/**
 * Iterates over `array` sequentially, awaiting `callback` for each item,
 * and resolving with an array of the new results.
 */
export async function asyncMap<T, U>(
  array: T[],
  callback: (item: T, index: number, array: T[]) => Promise<U>
): Promise<U[]> {
  const result: U[] = [];
  for (let i = 0; i < array.length; i++) {
    result.push(await callback(array[i], i, array));
  }
  return result;
}
